module.exports = __webpack_public_path__ + "static/media/58.f801bcb4.jpg";